import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { CircularProgress } from "@material-ui/core";

import ListingLayout from "../../Components/UI/ListingLayout";

import { printScore } from "../../Stores/Print/actions";
import { useStyles } from "./style";

const ReviewScore = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { activeLocation } = useSelector(
    (state) => state.SlickCareProfilesReducer
  );
  const { isPritingScore } = useSelector((state) => state.PrintReducer);

  const [pdfString, setPdfString] = useState("");
  const [loader, setLoader] = useState(true);

  let loading = loader || isPritingScore;

  const onSuccess = (blobPDF) => {
    let reader = new FileReader();
    reader.readAsDataURL(blobPDF);
    reader.onloadend = () => {
      let base64String = reader.result;
      setPdfString(base64String);
    };
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      dispatch(
        printScore(
          {
            location_id: activeLocation?.id,
          },
          onSuccess
        )
      );
      setLoader(false);
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [activeLocation]);

  return (
    <ListingLayout
      title="Review Score"
      item="ENQUIRIES"
      hideAdd={true}
      hasFilter={false}
      showLocationToggle={true}
    >
      <>
        {loading ? (
          <div className={classes.loaderWrap}>
            <CircularProgress size="40px" />
          </div>
        ) : (
          <embed src={`${pdfString}`} width={"100%"} height={800} />
        )}
      </>
    </ListingLayout>
  );
};

export default ReviewScore;
